import { EQUIPMENT_CATALOG_CHANGES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/equipment_catalog_changes_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['equipmentCataloghangeIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
